import { ButtonLinkTypeEnum } from 'common/enums/ButtonLinkEnum'
import StyleWrapper from 'publisher/components/core/StyleWrapper'
import { useFiles } from 'publisher/store'
import { getFile } from 'publisher/store/file/fileSelectors'
import React from 'react'
import { useCalculateButtonStyles } from 'src/publisher/shared/hooks/use-calculate-button-styles'
import { LinkButton as CommonLink } from 'src/shared/components/button/link-button-new'
import { DownloadFileActionButtonEntityInterface } from 'src/shared/entities/button/download-file.action-button.schema'
import { DownloadFileWebsiteActionButtonEntityInterface } from 'src/shared/entities/website-button/download-file-website-button.schema'

const TEST_ID = 'download-file-button'

export interface DownloadFileButtonProps {
  entity:
    | DownloadFileActionButtonEntityInterface
    | DownloadFileWebsiteActionButtonEntityInterface
}

const DownloadFileButton = ({ entity }: DownloadFileButtonProps) => {
  const file = useFiles(files => getFile(files, entity.fileId))
  const {
    calculatedBorder,
    calculatedPadding,
    calculatedFontSize,
    calculatedLineHeight,
    calculatedFontFamily,
    calculatedFontWeight,
    calculatedFontStyle,
    calculatedTextColor,
    calculatedBackground,
    calculatedHover,
  } = useCalculateButtonStyles({
    border: entity.border,
    mobileBorder: entity.mobileBorder,
    padding: entity.padding,
    mobilePadding: entity.mobilePadding,
    buttonType: entity.buttonType,
    fontSize: entity.textFontSize,
    mobileFontSize: entity.mobileTextFontSize,
    lineHeight: entity.lineHeight,
    mobileLineHeight: entity.mobileLineHeight,
    fontFamily: entity.textFontFamily,
    mobileFontFamily: entity.mobileTextFontFamily,
    fontWeight: entity.textFontWeight,
    mobileFontWeight: entity.mobileTextFontWeight,
    fontStyle: entity.textFontStyle,
    mobileFontStyle: entity.mobileTextFontStyle,
    textColor: entity.textColor,
    mobileTextColor: entity.mobileTextColor,
    background: entity.background,
    mobileBackground: entity.mobileBackground,
    backgroundColor: entity.backgroundColor,
    mobileBackgroundColor: entity.mobileBackgroundColor,
    hover: entity.hover,
    mobileHover: entity.mobileHover,
  })

  return (
    <StyleWrapper
      flex
      flexColumn
      margin={entity.margin}
      mobileMargin={entity.mobileMargin}
      appearance={entity.appearance}
    >
      <CommonLink
        dataTestId={TEST_ID}
        iconClassNameBefore={entity.iconClassNameBefore}
        iconClassNameAfter={entity.iconClassNameAfter}
        text={entity.text}
        border={calculatedBorder.desktop}
        mobileBorder={calculatedBorder.mobile}
        subText={entity.subText}
        padding={calculatedPadding.desktop}
        mobilePadding={calculatedPadding.mobile}
        alignSelf={entity.alignSelf}
        mobileAlignSelf={entity.mobileAlignSelf}
        background={calculatedBackground.desktop}
        mobileBackground={calculatedBackground.mobile}
        attrId={entity.htmlAttrId}
        width={entity.width}
        mobileWidth={entity.mobileWidth}
        textColor={calculatedTextColor.desktop}
        subTextColor={entity.subTextColor}
        mobileTextColor={calculatedTextColor.mobile}
        mobileSubTextColor={entity.mobileSubTextColor}
        textFontSize={calculatedFontSize.desktop}
        mobileTextFontSize={calculatedFontSize.mobile}
        subTextFontSize={entity.subTextFontSize}
        mobileSubTextFontSize={entity.mobileSubTextFontSize}
        textFontFamily={calculatedFontFamily.desktop}
        textFontWeight={calculatedFontWeight.desktop}
        textFontStyle={calculatedFontStyle.desktop}
        lineHeight={calculatedLineHeight.desktop}
        subTextFontFamily={entity.subTextFontFamily}
        subTextFontWeight={entity.subTextFontWeight}
        subTextFontStyle={entity.subTextFontStyle}
        mobileTextFontFamily={calculatedFontFamily.mobile}
        mobileTextFontWeight={calculatedFontWeight.mobile}
        mobileTextFontStyle={calculatedFontStyle.mobile}
        mobileLineHeight={calculatedLineHeight.mobile}
        mobileSubTextFontFamily={entity.mobileSubTextFontFamily}
        mobileSubTextFontWeight={entity.mobileSubTextFontWeight}
        mobileSubTextFontStyle={entity.mobileSubTextFontStyle}
        boxShadow={entity.boxShadow}
        mobileBoxShadow={entity.mobileBoxShadow}
        hover={calculatedHover.desktop}
        mobileHover={calculatedHover.mobile}
        href={file ? file.path : ''}
        target={ButtonLinkTypeEnum.openInNewWindow}
      />
    </StyleWrapper>
  )
}

export default DownloadFileButton
